export async function urlToFile(url: string, filename: string): Promise<File> {
  const response = await fetch(url);
  const buffer = await response.arrayBuffer();
  const type = getMimeTypeFromDataUrl(url);
  const ext = getExtensionFromMimeType(type);
  return new File([buffer], `${filename}.${ext}`, {
    type,
  });
}

function getMimeTypeFromDataUrl(url: string): string {
  return url.substring(url.indexOf(":") + 1, url.indexOf(";"))
}

function getExtensionFromMimeType(mime: string): string {
  const [, ext] = mime.split('/');
  return ext;
}
